import { Injectable } from '@angular/core';
import { ProductNavbarProvider } from './product-navbar';
import { ProductNavbar } from '@feature/navbar/services/product-navbar';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { MciNavbarService } from './mci-navbar.service';
import { MfsNavbarService } from './mfs-navbar.service';
import { MftNavbarService } from './mft-navbar.service';
import { MojoPmaNavbarService } from './mojopma-navbar.service';

@Injectable({
  providedIn: 'root'
})
export class ProductNavbarProviderService implements ProductNavbarProvider {

  constructor(
    private readonly mci: MciNavbarService,
    private readonly mfs: MfsNavbarService,
    private readonly mft: MftNavbarService,
    private readonly mojopma: MojoPmaNavbarService,
    ) { }

  getProductNavbar(product: string): ProductNavbar {
    switch (product) {
      case MojoWellKnownNames.Products.MojoDashboard:
        return this.mojopma;
      case MojoWellKnownNames.Products.Mci:
        return this.mci;
      case MojoWellKnownNames.Products.MojoForSuppliers:
        return this.mfs;
      case MojoWellKnownNames.Products.MojoForTenants:
        return this.mft;
      default:
        throw new Error('No navbar for product');
    }

  }


}
